export const publicationLetterGroups: { [key: string]: string } = {
  A: 'A',
  'B-I': 'BCDEFGHI',
  'J-Z': 'JKLMNOPQRSTUVWXYZ',
};
